var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFollowerVine2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2560 1440",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: 0,
    y1: 0,
    x2: 50,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#264d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5fae8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b2f0e3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m252.96,1835.93c-238.89,-148.15 -262.96,-422.22 -188.89,-538.89c74.07,-116.67 179.63,-116.67 172.22,-264.81c-7.41,-148.15 -174.07,-157.41 -175.93,-322.22c-1.85,-164.81 83.33,-325.93 205.56,-414.81c122.22,-88.89 350,-168.52 350,20.37c0,188.89 -51.85,237.04 -164.81,344.44c-112.96,107.41 -77.78,250 -37.04,340.74c40.74,90.74 124.07,214.81 274.07,244.44c150,29.63 303.7,16.67 320.37,-125.93c16.67,-142.59 -72.22,-229.63 7.41,-357.41c79.63,-127.78 277.78,-12.96 324.07,-231.48c46.3,-218.52 -135.19,-503.7 -283.33,-631.48c-148.15,-127.78 -142.59,-68.52 -143.7,-622.96c-1.11,-554.44 767.78,-17.78 766.67,-16.67c-1.11,1.11 219.63,130.37 296.3,333.33c76.67,202.96 -2.59,330.37 73.33,489.63c75.93,159.26 277.78,137.04 307.41,324.07c29.63,187.04 -311.11,77.78 -345.56,269.63c-34.44,191.85 125.19,274.81 137.04,409.26c11.85,134.44 -113.7,280.37 -277.78,255.56c-164.07,-24.81 -328.52,-154.81 -489.63,-104.81c-161.11,50 -229.63,175.93 -231.48,383.33c-1.85,207.41 -222.22,166.67 -293.7,165.93c-71.48,-0.74 -363.7,198.89 -602.59,50.74z",
    fill: "#000000",
    fillOpacity: 0,
    id: "svg_20",
    stroke: "#000000",
    strokeWidth: 20,
    transform: "matrix(1 0 0 1 0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowerVine2);
export default __webpack_public_path__ + "static/media/followerVine2.e9c4c7bc71cb85595dd513db2d94ae48.svg";
export { ForwardRef as ReactComponent };